import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import _slideLoader from '../utilities/slideLoader';
import EventMg from '../utilities/EventManager';
import { messageUtility } from '../utilities/messageUtility';
import ReportNames from '../utilities/reportNames';
import {
  isPrimaryCompanyRoleId,
  isPartnerCompanyRoleId,
} from '../utilities/roleUtility';
import PrintUtility from '../utilities/printUtility';

import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import dialogLoader from '../utilities/dialogLoader';

import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { PrintService } from '../services/Prints'; // 帳票API
import { GateService } from '../services/Gates';
import { GatePassageService } from '../services/GatePassages';
import { ScheduleLimitTimeService } from '../services/ScheduleLimitTimes';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import { SchaduleBar } from '../components/gagebar/bar';
import { isTargetRoleId } from '../utilities/roleUtility';

import {
  WORK_HOUR_ZONES, // 作業時間帯
  APPROVAL_STATUS, // 承認フラグ
  SCHEDULE_TYPES, // 予定種別
  HEADER_CONSTANTS, // ヘッダータイトル
  FILE_CODE,
  CONFERENCE_MODE, //会議モード
  STATUS_CODE,
  USER_ROLES,
  LIST_LIMIT,
  USER_ROLES_IDS,
  ONLY_EDIT_VEHICLE_NUMBER,
} from '../utilities/constants';

import { Modal } from '../components/Modal';
import Confirmation from '../components/modals/common/Confirmation';
import PrimeContractorToggle from '../components/toggle/PrimeContractorToggle';
import DisableTime from '../components/modals/common/DisableTime';
import CopyPlan from '../components/modals/common/CopyPlan';
import Information from '../components/modals/common/Information';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { GatePassagesContents } from '../components/tables/GatePassages';
import { GatePassagesSearchForm } from '../components/searchmenus/GatePassages';

import { GatePassageDocuments } from './modals/Commons';
import { TimeBarHeader } from '../components/gagebar/bar';
import GroupListContainer from './GroupListContainer';
import urlParamManager from '../utilities/urlParamManager';
import _dialogLoader from '../utilities/dialogLoader';
import { onceAsyncRequest } from '../utilities/commonUtil';
import { isEditConcurrentErrorGate, isStatusAcceptGateFutral } from '../utilities/gatePassageUtil';
import { ConferencePageHeader } from '../components/PageHeader';
import { VehicleNumberDialog } from '../components/modals/VehicleNumberDialog';
import { FormInformationDialog } from '../components/FormInformationDialog';

const MY_EVENT = {
  LOAD_GATE_PASSAGES_DATA: 'load_gate_passages_data', // 一覧取得
};

// 絞り込みキー
const paramsDefault = {
  approval_flag: null,
  crane_use: null,
  spot_flag: null,
  gate_id: [],
  field_tree_id: [],
  manager_user_id: [],
  field_group_id: [],
  status_code: [],
};

/**
 * @description ゲート予定一覧画面
 */
class GatePassagesBody extends React.Component {
  constructor(props) {
    super(props);

    this._scroller = React.createRef();
    this._rightTable = React.createRef();
    this.innerWindow = React.createRef();
    this.isUpdatingFlag = false;

    // カレンダー指定時間をStateに反映する
    const fromDate = SessionStorageService.getItem('date_from');
    const toDate = SessionStorageService.getItem('date_to');
    const workHourZone = SessionStorageService.getItem('work_hour_zone');

    const roleId = LocalStorageService.getRoleId();
    const currentStartDate = SessionStorageService.getFromDate();
    let viewOnlyFlag = false;
    if (
      isPartnerCompanyRoleId(roleId) &&
      moment(currentStartDate).isBefore(moment().format('YYYY/MM/DD'))
    ) {
      viewOnlyFlag = true;
    }

    this.state = {
      total: 0,
      fieldId: SessionStorageService.getFieldId(),
      roleId,
      fromDate,
      toDate,
      workHourZone,
      viewOnlyFlag, // 閲覧制限フラグ

      selectedList: {}, // 選択したゲート予定のIDを格納
      // { groupId1: [itemId1, itemId2, ... ], groupId2: ... }
      // という形式で値が入っている

      selectedGroup: {}, // グループ単位で選択したゲートマスタをboolで管理
      // { groupId1: true, groupId2: true }
      // という形式で値が入っている

      isOpened: false, // 検索フォームの開閉フラグ
      refresh: false, // 検索条件クリアフラグ
      passage_date: moment().format('YYYY/MM/DD'), // コピーする日付
      workTime: {}, // 現場に設定されている作業時間を格納
      calling: false, // 帳票通信中フラグ
      message: '', // 禁止時間帯
      modalVisible: {
        // ダイアログの表示・非表示フラグ
        approval: false, // 承認
        disapproval: false, // 承認解除
        approvalSingle: false, // 行単位の承認
        disapprovalSingle: false, // 行単位の承認解除
        disableTime: false, // 禁止時間帯
        documents: false, // 帳票
        confirmation: false, // 禁止時間帯削除確認
        approvalStatus: false, // 承認状態
        approvalTitle: '', // 承認/承認解除結果ダイヤログのタイトル
        approvalMessage: '', // 承認、未承認時のメッセージ
        failure: false, //禁止時間帯削除失敗
        timeForbiddenError: false, // 時間更新権限エラー
        copyForbiddenError: false, // コピー権限エラー
        copyNotComplete: false, // 不完全コピー：作業終了の元請担当者はクリアしてコピー
      },
      searchConditions: _.cloneDeep(paramsDefault), // 検索条件
      tempSearchConditions: _.cloneDeep(paramsDefault), // 検索条件(保存用)
      scheduleLimitTimes: [
        {
          schedule_type: SCHEDULE_TYPES.gate.id,
          target_id: '',
          limit_start_date: fromDate,
          limit_start_time: '',
          limit_end_time: '',
        },
      ],
      disabledTimes: [],
      loadingDisabledTimes: false,
      deleteScheduleLimitTimeIds: [], // 削除禁止時間帯設定ID
      isTimeBarReset: false, // 時間バーリセットフラグ
      clientX: 0,
      scrollLeft: 0,
      isScrolling: false,
      ref: this._scroller,
      innerWidth: window.innerWidth,
      useConstructionSiteCodeFlg: false,
    };

    //新規フォーム用のコールバックと値
    this.FormNew = {
      callback: {
        submit: () => {},
      },
      state: { currentDate: this.state.fromDate },
      // GatePassageRegister.jsx に
      // this.props.view.state.currentDate
      // として値が伝達される
    };

    this.events = {
      modal: {
        handleVisible: this.handleVisible.bind(this), // ダイアログ表示・非表示イベント
        approval: this.approvalGatePassages.bind(this), // 承認
        disapproval: this.disapprovalGatePassages.bind(this), // 否認
        copy: this.copyGatePassages.bind(this), // コピー
        calender: this.setDate.bind(this),
        dropdown: this.setDisableGatePassages.bind(this), // ドロップダウンで選択した値をセット
        destroy: this.destroyScheduleLimitTimes.bind(this), // 禁止時間帯クリア
        add: this.addLimitTime.bind(this), // 禁止時間帯追加
        set: this.setLimitTime.bind(this), // 禁止時間帯設定
        remove: this.removeLimitTime.bind(this), // 禁止時間帯追加項目削除
        submit: this.updateDisabledTimes.bind(this), // 禁止時間帯設定API
        print: {
          // 帳票
          dailyGatePassage: this.printDailyGatePassage.bind(this), // 車輌一覧（日次）
          weeklyGatePassage: this.printWeeklyGatePassage.bind(this), // 車輌一覧（週間）
          monthlyGatePassage: this.printMonthlyGatePassage.bind(this), // 車輌搬出入予定月間集計表
        },
      },
      search: {
        handleFormOpen: this.handleFormOpen.bind(this), // 検索フォーム開閉イベント
        clearConditions: this.clearConditions.bind(this), // 検索条件クリア
        setSingleCondition: this.setSingleCondition.bind(this), // 承認・スポットフラグを検索条件にセット
        dropdown: this.setMultiCondition.bind(this), // ドロップダウンで選択した値をセット
        setSearchCondition: this.setSearchCondition, // 検索条件にセット
      },
      table: {
        handleSelectedRow: this.handleSelectedRow.bind(this), // ゲート予定を単一選択
        handleSelectedAll: this.handleSelectedAll.bind(this), // 取得したゲート予定を全選択
        handleSelectedGroup: this.handleSelectedGroup.bind(this), // ゲート予定をグループ単位で選択
        handleSeeMore: this.fetchGatePassages.bind(this), // ゲートマスタ単位で揚重機予定を10件取得
        handleGageUpdate: this.handleGageUpdate.bind(this), //ゲージの時間更新
        handleOpenVehicleNumberDialog: this.handleOpenVehicleNumberDialog,
        edit: this.editRow.bind(this), // 編集画面へ遷移
        craneEdit: this.craneEdit.bind(this),
      },
    };

    this.checkShadow = this.checkShadow.bind(this);
    this.getGates = this.getGates.bind(this); // ゲートマスタ取得
    this.getAddGates = this.getAddGates.bind(this); // ゲートマスタ取得 InfinityScrollLoad用
    this.reLoad = this.reLoad.bind(this); // ゲートマスタ取得
    this.getTotal = this.getTotal.bind(this); // 総数取得
    this.isSelected = this.isSelected.bind(this); // 単一選択判定
    this.createParams = this.createParams.bind(this); // 承認・否認する際のparam生成
    this.isSelectedGroup = this.isSelectedGroup.bind(this); // ゲート予定のグループ選択済み判定
    this.isShowRegisterButton = this.isShowRegisterButton.bind(this);
    this.someSelectedList = this.someSelectedList.bind(this); // 選択したデータがあるか判定
    this.updateApprovalFlgGatePassages = this.updateApprovalFlgGatePassages.bind(
      this
    ); // stateに保持しているゲート予定と、更新したゲート予定を書き換える
    this.getDisabledTimes = this.getDisabledTimes.bind(this); // 予定禁止時間取得

    // 一覧取得イベント登録
    EventMg.registerEvent(MY_EVENT.LOAD_GATE_PASSAGES_DATA);
    EventMg.addEventListener(MY_EVENT.LOAD_GATE_PASSAGES_DATA, isNotUpdate => {
      if (!isNotUpdate) {
        this.reLoad();
      }
    });

    this.allChecked = false;
    this.allUnChecked = false;
    this.clearFlag = false;
    this.isUpdatingFlagSchaduleBar = false;
    this.isRequestingFlag = false;
  }

  componentDidMount() {
    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const field = response.data.entities.field;
        let workTime = this.state.workTime;
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { start: field.work_start_time }
        ); // 労働開始時刻（昼）
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { end: field.work_end_time }
        ); // 労働終了時刻（昼）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { start: field.work_start_time_night }
        ); // 労働開始時刻（夜）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { end: field.work_end_time_night }
        ); // 労働終了時刻（夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { start: field.work_start_time_midnight }
        ); // 労働開始時刻（深夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { end: field.work_end_time_midnight }
        ); // 労働終了時刻（深夜）

        // 作業時間帯
        let scheduleLimitTimes = this.state.scheduleLimitTimes;
        scheduleLimitTimes[0].limit_start_time =
          workTime[this.state.workHourZone].start;
        scheduleLimitTimes[0].limit_end_time =
          workTime[this.state.workHourZone].end;
        if (
          scheduleLimitTimes[0].limit_start_time === '00:00:00' &&
          scheduleLimitTimes[0].limit_end_time === '00:00:00'
        ) {
          scheduleLimitTimes[0].limit_end_time = '24:00:00';
        }

        this.setState(
          {
            workTime,
            scheduleLimitTimes,
            useConstructionSiteCodeFlg: field.use_construction_site_code_flag,
          },
          () => {
            this.getDisabledTimes();
          }
        );
      }
    });

    this.getGates(() => {});
    this.getTotal();

    window.addEventListener('resize', _.throttle(this.checkWindow, 500));
    window.addEventListener('resize', _.throttle(this.checkShadow, 100));
    this._scroller.current.addEventListener(
      'scroll',
      _.throttle(this.checkShadow, 100)
    );
    // マスターメニュー・機能一覧メニューの開閉の時にゲージのrender再計算を実行
    const masterNavi = document.getElementById('master-navi');
    const slideNavi = document.getElementById('func-navi--item1');
    const slideSizeObserver = new MutationObserver(() => {
      this.checkWindow();
      this.checkShadow();
    });
    const slideSizeObserverParams = {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    };
    slideSizeObserver.observe(masterNavi, slideSizeObserverParams);
    slideSizeObserver.observe(slideNavi, slideSizeObserverParams);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
    if (this.state.isTimeBarReset) {
      this.setState({ isTimeBarReset: false });
    }

    if (prevState.isScrolling !== this.state.isScrolling) {
      this.toggleScrolling(this.state.isScrolling);
    }
    if (prevState.isConferenceMode !== this.state.isConferenceMode) {
      this.checkWindow();
      this.checkShadow();
    }
    if (!_.isEqual(prevProps.items, this.props.items)) {
      this.checkWindow();
      this.checkShadow();
    }
    if (prevState.loadingDisabledTimes !== this.state.loadingDisabledTimes) {
      this.checkWindow();
      this.checkShadow();
    }
    if (prevState.innerWidth !== this.state.innerWidth) {
      this.checkShadow();
    }

    const isConferenceMode =
      SessionStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key;
    if (isConferenceMode !== this.state.isConferenceMode) {
      this.setState({ isConferenceMode });
    }
  }

  componentWillUnmount() {
    EventMg.deleteEvent(MY_EVENT.LOAD_GATE_PASSAGES_DATA);
    window.removeEventListener('resize', _.throttle(this.checkShadow, 100));
    window.removeEventListener('resize', _.throttle(this.checkWindow, 500));
    this._scroller.current.removeEventListener(
      'scroll',
      _.throttle(this.checkShadow, 100)
    );
  }

  toggleScrolling = isScrolling => {
    if (isScrolling) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  };

  onMouseMove = event => {
    if (this.state.isScrolling) {
      const { clientX, scrollLeft } = this.state;
      const scroller = this._scroller.current;
      scroller.scrollLeft = scrollLeft + clientX - event.clientX;
      this.checkShadow();
    }
  };

  onMouseUp = () => {
    window.removeEventListener('mousemove', this.onMouseMove);
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      clientX: 0,
    });
  };

  onMouseDown = event => {
    const { scrollLeft } = this._scroller.current;
    this.setState({
      isScrolling: true,
      scrollLeft,
      clientX: event.clientX,
    });
  };

  /**
   * 横スクロールヒント用の影チェック
   *
   */
  checkShadow = () => {
    const scroller = this._scroller.current;
    if (_.isNull(scroller) || _.isNull(this._rightTable.current)) {
      return;
    }
    if (
      this.state.total === 0
      // || LocalStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key
    ) {
      return this._rightTable.current.classList.add('no-shadow');
    }
    // 端数が出る場合があるので判定を1緩める
    if (
      scroller.scrollWidth <=
      1 + scroller.scrollLeft + scroller.offsetWidth
    ) {
      this._rightTable.current.classList.add('no-shadow');
    } else {
      this._rightTable.current.classList.remove('no-shadow');
    }
  };

  checkWindow = () => {
    if (!_.isNull(this.innerWindow.current)) {
      const innerWidth = this.innerWindow.current.offsetWidth;
      this.setState({ innerWidth });
    }
  };

  // 24時間内に設定する
  convertTime24 = time => {
    return parseInt(time.split(':')[0]) >= 24
      ? `${parseInt(time.split(':')[0]) - 24}:${time.split(':')[1]}`
      : time;
  };

  /**
   * 検索フォーム開閉
   */
  handleFormOpen = () => {
    if (!this.state.isFirstFormOpened && !this.state.isFormOpen) {
      // 1回でも開いたかどうかを保持する
      this.setState({
        isFirstFormOpened: true,
      });
    }
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 検索条件クリア
   */
  clearConditions = () => {
    // 連打防止, GroupListContainer.jsのisLoadingを見る
    if (this.props.isLoading) {
      return;
    }
    this.clearFlag = true;
    const SearchDropdown = document.querySelectorAll('.SearchDropdown');
    _.each(SearchDropdown, dropDown => {
      dropDown.value = '';
    });
    this.setState(
      {
        searchConditions: _.cloneDeep(paramsDefault),
        tempSearchConditions: _.cloneDeep(paramsDefault),
        refresh: true,
        selectedGroup: {},
        selectedList: {},
      },
      () => {
        this.getGates(() => {});
        this.getTotal();
      }
    );
  };

  /**
   * ダイアログ表示・非表示
   * @params key {string}
   */
  handleVisible = (key, approvalMessage) => {
    const modalState = {};
    const visible = !this.state.modalVisible[key];
    modalState[key] = visible;
    if (key === 'disableTime' || key === 'success') {
      this.getDisabledTimes();
    }
    if (!_.isUndefined(approvalMessage)) {
      if (approvalMessage === '') {
        modalState[key] = !visible;
      } else {
        modalState['approvalMessage'] = approvalMessage;
        modalState['approvalTitle'] = this.state.modalVisible.approvalTitle;
      }
    }
    this.setState({
      message: '',
      modalVisible: modalState,
      passage_date: moment().format('YYYY/MM/DD'),
      deleteScheduleLimitTimeIds: [],
    });
  };

  getDisabledTimes() {
    this.setState(
      {
        loadingDisabledTimes: true,
      },
      () => {
        ScheduleLimitTimeService.list(this.state.fieldId, {
          schedule_type: SCHEDULE_TYPES.gate.id,
          isQuiet: true,
        }).then(response => {
          if (response.result) {
            if (response.data.total >= 0) {
              let disabledTimes = [];
              _.each(
                response.data.entities.schedule_limit_times,
                disabledTime => {
                  disabledTimes.push({
                    id: disabledTime.id,
                    update: true,
                    changed: false,
                    schedule_type: SCHEDULE_TYPES.gate.id,
                    target_id: disabledTime.target_id,
                    target_name: disabledTime.target_name,
                    limit_start_date: this.state.fromDate,
                    limit_start_time: disabledTime.limit_start_time,
                    limit_end_time: disabledTime.limit_end_time,
                  });
                }
              );
              this.setState({ disabledTimes, loadingDisabledTimes: false });
            }
          }
        });
      }
    );
  }

  /**
   * 検索条件(保存用)セット（単数）
   */
  setSingleCondition = e => {
    this.setState(prevState => ({
      tempSearchConditions: {
        ...prevState.tempSearchConditions,
        [e.target.name]: e.target.value,
      },
    }));
  };

  /**
   * 検索条件セット
   */
  setSearchCondition = () => {
    if (this.props.isLoading) {
      return;
    }
    const searchConditions = _.cloneDeep(this.state.tempSearchConditions);
    this.setState(
      {
        selectedGroup: {},
        selectedList: {},
        searchConditions,
      },
      () => {
        this.getGates(() => {});
        this.getTotal();
      }
    );
  };

  /**
   * 禁止時間帯機材セット
   * @parmas key {int}
   * @parmas selected {object} // 選択した値
   */
  setDisableGatePassages = (key, selected) => {
    let disabledTimes = _.cloneDeep(this.state.disabledTimes);
    disabledTimes[key].target_id = selected;
    disabledTimes[key].changed = true;
    this.setState({ disabledTimes });
  };

  /**
   * 禁止時間帯追加
   */
  addLimitTime = (init = false) => {
    let disabledTimes = this.state.disabledTimes;
    if (init) {
      disabledTimes = [];
    }
    const workTime = this.state.workTime;
    const disabledTime = {
      schedule_type: SCHEDULE_TYPES.gate.id,
      target_id: '',
      changed: false,
      limit_start_date: this.state.fromDate,
      limit_start_time: workTime[this.state.workHourZone].start,
      limit_end_time: workTime[this.state.workHourZone].end,
    };
    disabledTimes.push(disabledTime);
    this.setState({ disabledTimes });
  };

  /**
   * 禁止時間帯設定
   */
  setLimitTime = (e, key) => {
    const selectedIndex = e.target.selectedIndex;
    const selected = e.target.options[selectedIndex];
    const selectedDate = selected.getAttribute('data-select');
    const target = moment(selectedDate);
    let disabledTimes = _.cloneDeep(this.state.disabledTimes);
    const name = e.target.name;
    const value = e.target.value;
    disabledTimes[key][name] = value;
    disabledTimes[key]['changed'] = true;
    if (name === 'limit_start_time') {
      if (!disabledTimes[key].limit_end_time) {
        disabledTimes[key].limit_end_time = target
          .add(15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const endSelect = document.getElementById(
          `gate-passages-limit-end-time-${key}`
        );
        const endIndex = endSelect.selectedIndex;
        const endSelected = endSelect.options[endIndex];
        const end = moment(endSelected.getAttribute('data-select'));
        if (end.isSameOrBefore(target)) {
          disabledTimes[key].limit_end_time = target
            .add(15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    } else if (name === 'limit_end_time') {
      if (!disabledTimes[key].limit_start_time) {
        disabledTimes[key].limit_start_time = target
          .add(-15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const startSelect = document.getElementById(
          `gate-passages-limit-start-time-${key}`
        );
        const startIndex = startSelect.selectedIndex;
        const startSelected = startSelect.options[startIndex];
        const start = moment(startSelected.getAttribute('data-select'));
        if (start.isSameOrAfter(target)) {
          disabledTimes[key].limit_start_time = target
            .add(-15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    }
    this.setState({ disabledTimes });
  };

  /**
   * 禁止時間帯追加項目削除
   * @param key {int}
   */
  removeLimitTime = key => {
    const { disabledTimes } = this.state;
    const deleteScheduleLimitTimeIds = [
      ...this.state.deleteScheduleLimitTimeIds,
    ];
    let times = [];
    _.each(disabledTimes, (disabledTime, index) => {
      if (index !== key) {
        times.push(disabledTime);
      } else {
        if (!_.isUndefined(disabledTime.id)) {
          deleteScheduleLimitTimeIds.push(disabledTime.id);
        }
      }
    });
    this.setState({ disabledTimes: times, deleteScheduleLimitTimeIds });
  };

  /**
   * 検索条件(保存用)セット（複数）
   * @parmas name {string}
   * @parmas selected {array} // 選択した値
   */
  setMultiCondition = (name, selected) => {
    this.setState(prevState => ({
      tempSearchConditions: {
        ...prevState.tempSearchConditions,
        [name]: selected,
      },
      refresh: false,
    }));
  };

  /**
   * ゲート予定単一選択
   * @params gateId {int}
   * @params selected {boolean} // 選択済み判定
   */
  handleSelectedRow = (e, gateId, selected) => {
    // console.log(
    //   'GatePassages.jsx handleSelectedRow',
    //   this.state,
    //   this.props.items
    // );
    const selectedList = { ...this.state.selectedList };
    const selectedGroup = { ...this.state.selectedGroup };
    const gatePassagesId = parseInt(e.target.value, 10);
    if (selected) {
      if (_.isUndefined(selectedList[gateId])) {
        selectedList[gateId] = [];
      }
      if (!selectedList[gateId].includes(gatePassagesId)) {
        selectedList[gateId].push(gatePassagesId);
      }
      // 選択した項目が所属するグループが全チェックされているなら
      // グループ項目をチェックする
      if (
        selectedList[gateId].length ===
        this.props.items.find(item => item.id === gateId).children.length
      ) {
        selectedGroup[gateId] = true;
      }
    } else {
      _.remove(selectedList[gateId], gatePassage => {
        return parseInt(gatePassage, 10) === gatePassagesId;
      });
      selectedGroup[gateId] = false;
    }
    this.setState({
      selectedList,
      selectedGroup,
    });
  };

  /**
   * 日付セット
   */
  setDate = (name, date) => {
    let state = this.state;
    if (state[name] !== date) {
      state[name] = date;
      this.setState(state);
    }
  };

  /**
   * 取得したデータ全選択
   * @params selected {boolean} 選択したかどうか判定
   */
  handleSelectedAll = selected => {
    if (this.allChecked && selected) {
      return;
    } else if (this.allUnChecked && !selected) {
      return;
    }
    let selectedList = {};
    let selectedGroup = {};
    if (selected) {
      _.each(this.props.items, gate => {
        selectedList[gate.id] = [];
        selectedGroup[gate.id] = true;
        _.each(gate.children, gatePassage =>
          selectedList[gate.id].push(parseInt(gatePassage.id))
        );
      });
    }
    this.setState({
      selectedGroup,
      selectedList,
    });
  };

  /**
   * 全て選択されているか確認
   */
  checkAllSelected(selectedList = this.state.selectedList) {
    let gatesCnt = 0;
    _.each(this.props.items, gate => {
      if (_.has(gate, 'children')) {
        gatesCnt = gatesCnt + gate.children.length;
      }
    });
    let selectedCnt = 0;
    _.each(selectedList, gate => {
      selectedCnt = selectedCnt + gate.length;
    });
    this.allChecked = gatesCnt === selectedCnt;
    this.allUnChecked = selectedCnt === 0;
  }

  /**
   * グループ単位で選択
   * @params checked {boolean} // 選択判定
   * @params gateId {int}
   */
  handleSelectedGroup = (checked, gateId) => {
    const selectedList = { ...this.state.selectedList };
    const selectedGroup = { ...this.state.selectedGroup };
    if (checked) {
      if (_.isEmpty(selectedList[gateId])) {
        selectedList[gateId] = [];
      }
      const group = _.find(this.props.items, item => item.id === gateId);
      _.each(group.children, gatePassage => {
        selectedList[gateId].push(Number(gatePassage.id));
      });
      selectedGroup[gateId] = true;
    } else {
      delete selectedList[gateId];
      selectedGroup[gateId] = false;
    }

    this.setState({ selectedGroup, selectedList });
  };

  /**
   * 時間の更新
   * @params data {object}
   * @params useWorkTime {object}
   */
  async handleGageUpdate(data, useWorkTime) {
    if (
      data.passage_start_time === useWorkTime.start &&
      data.passage_end_time === useWorkTime.end
    ) {
      return;
    }
    if (this.isUpdatingFlagSchaduleBar) {
      return;
    }
    this.isUpdatingFlagSchaduleBar = true;
    let params = {
      field_id: this.state.fieldId,
      gate_id: data.gate_id,
      use_date: data.use_date,
      today_receipt_no: data.today_receipt_no,
      passage_start_time: moment(
        this.convertTime24(useWorkTime.start),
        'HH:mm'
      ).format('HH:mm:ss'),
      passage_end_time: moment(
        this.convertTime24(useWorkTime.end),
        'HH:mm'
      ).format('HH:mm:ss'),
      work_hour_zone: this.state.workHourZone,
      lock_version: data.lock_version,
    };
    let promise = new Promise(resolve => {
      GatePassageService.gageUpdate(this.state.fieldId, data.id, params)
        .then(async response => {
          if (response.result) {
            await this.reLoad();
            resolve(response.result);
          } else {
            if (isEditConcurrentErrorGate(response)) {
              return _dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-001-402'),
                message: messageUtility.getMessage('E-001-436'),
                onClose: () => {
                  window.location.reload();
                },
              });
            }
            //エラーメッセージを表示する
            alert('時間の更新に失敗しました。');
          }
        })
        .catch(error => {
          if (error.status === 403) {
            this.events.modal.handleVisible('timeForbiddenError');
            this.setState({ isTimeBarReset: true });
          }
        })
        .finally(() => {
          this.isUpdatingFlagSchaduleBar = false;
        });
    });
    return promise;
  }

  handleOpenVehicleNumberDialog = async values => {
    const { fieldId } = this.state;
    const response = await GatePassageService.show(fieldId, values.id);
    let vehicleNumbers = [];
    if (response.result) {
      vehicleNumbers = _.get(
        response,
        'data.entities.gate_passage.vehicle_numbers'
      );
      dialogLoader.show(VehicleNumberDialog, {
        vehicleNumbers,
        callback: {
          save: async vehicleNumbers => {
            if (this.isUpdatingFlag) {
              return;
            }
            this.isUpdatingFlag = true;
            const params = _.cloneDeep(values);
            params.vehicle_numbers = vehicleNumbers;
            params.editing_vehicle_numbers_flag = ONLY_EDIT_VEHICLE_NUMBER;
            const response = await GatePassageService.update(
              fieldId,
              params.id,
              params
            );
            if (response.result) {
              const gatePassage = _.get(response, 'data.entities.gate_passage');
              this.props.setItems(gatePassage);
            }
            this.isUpdatingFlag = false;
            dialogLoader.close();
            if (
              isEditConcurrentErrorGate(response)
            ) {
              return dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-001-402'),
                message: messageUtility.getMessage('E-001-436'),
                onClose: () => {
                  window.location.reload();
                },
              });
            }
          },
          close: () => {
            dialogLoader.close();
          },
        },
      });
    }
  };

  /**
   * グループ単位の選択があるか判定
   * @params gateId {int}
   * @return boolean
   */
  isSelectedGroup(gateId) {
    return this.state.selectedGroup[gateId];
  }

  /**
   * ゲート予定の選択判定
   * @params gateId {int}
   * @params gatePassageId {int}
   */
  isSelected(gateId, gatePassageId) {
    let bool = false;
    if (_.indexOf(this.state.selectedList[gateId], gatePassageId) !== -1) {
      bool = true;
    }
    return bool;
  }

  getParentLoadParams = () => {
    return {
      field_id: this.state.fieldId,
      passage_date_from: this.state.fromDate,
      passage_date_to: this.state.toDate,
      work_hour_zone: this.state.workHourZone,
      limit: LIST_LIMIT.GATE.PARENT,
      ...this.state.searchConditions,
    };
  };

  getChildLoadParams = parents => {
    // 親の配列から指定するので検索条件のgate_idは除く
    const searchConditions = _.omit(this.state.searchConditions, 'gate_id');
    return {
      passage_date_from: this.state.fromDate,
      passage_date_to: this.state.toDate,
      gate_ids: _.map(parents, 'id'),
      work_hour_zone: this.state.workHourZone,
      limit: LIST_LIMIT.GATE.CHILD,
      ...searchConditions,
    };
  };

  /**
   * ゲートマスタ取得
   */
  async getGates(notify) {
    await this.props.load(
      this.getParentLoadParams,
      this.getChildLoadParams,
      notify
    );
  }

  // インフィニティスクロールでのゲートマスタの取得
  async getAddGates(notify) {
    await this.props.addGroupsLoad(
      this.getParentLoadParams,
      this.getChildLoadParams,
      notify
    );
  }

  async reLoad() {
    this.setState({
      selectedList: {},
      selectedGroup: {},
    });
    await this.props.reLoad(this.getParentLoadParams, this.getChildLoadParams);
    this.getTotal();
  }

  /**
   * ゲートマスタのorder_numberでソートしたリストを取得
   */
  getOrderedGates(gates) {
    return _.sortBy(gates, 'order_number');
  }

  /**
   * 総数取得
   */
  getTotal() {
    let params = {
      // 通過年月日(開始)
      passage_date_from: this.state.fromDate,
      // 通過年月日(終了)
      passage_date_to: this.state.toDate,
      // 勤務時間帯種別 1:昼間、2:夜間、3:深夜
      work_hour_zone: this.state.workHourZone,
    };

    params = _.merge(params, this.state.searchConditions);
    GatePassageService.total(this.state.fieldId, params).then(response => {
      if (response.result) {
        this.setState({ total: response.data.total }, () => {
          this.checkShadow();
        });
      }
    });
  }

  /**
   * ゲート予定追加取得
   * 「さらに表示する」機能
   * @params gateId {int}
   */
  async fetchGatePassages(gateId) {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    const parent = _.find(this.props.items, item => item.id === gateId);
    await this.props.addChildrenLoad(parent, this.getChildLoadParams);
    this.isRequestingFlag = false;
  }

  /**
   * 承認・否認時のAPIパラメータ生成
   * @params approvalFlag
   * @return array
   */
  createParams(approvalFlag) {
    let params = {
      gate_passages: [],
    };

    const listGate = {};
    _.forEach(this.props.items, item => {
      _.forEach(item.children, child => {
        listGate[child.id] = child;
      })
    })
    _.each(this.state.selectedList, gate =>
      _.each(gate, gatePassage => {
        let param = {
          id: gatePassage,
          approval_flag: approvalFlag,
          lock_version: listGate[gatePassage].lock_version,
        };
        params.gate_passages.push(param);
      })
    );

    return params;
  }

  /**
   * 承認フラグの更新
   * @params approvalFlag
   */
  updateApprovalFlgGatePassages(approvalFlag) {
    const params = this.createParams(approvalFlag);

    this.updateApprovalFlgList(params);
  }

  updateApprovalFlgList = onceAsyncRequest(
    async (params) => {
      await GatePassageService.updateList(this.state.fieldId, params).then(
        response => {
          if (response.result === false || response.data.result === false) {
            if (isEditConcurrentErrorGate(response.data)) {
              dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-001-402'),
                message: messageUtility.getMessage('E-001-436'),
                onClose: () => {
                  window.location.reload();
                },
              });
            }
            return;
          }

          // 承認/承認解除結果ダイヤログのタイトル
          let approvalTitle = `${SCHEDULE_TYPES.gate.name}予定の承認${
            params.gate_passages[0].approval_flag ? '' : '解除'
          }${response.message.includes('完了') ? '完了' : ''}`;
          this.setState({
            modalVisible: {
              ...this.state.modalVisible,
              approvalTitle,
            },
          });

          //更新後は最新の情報を表示するためにリロードする
          this.reLoad();

          this.events.modal.handleVisible('approvalStatus', response.message);
        }
      );
    }
  );

  /**
   * 承認
   */
  approvalGatePassages() {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('approval');
    } else {
      this.updateApprovalFlgGatePassages(APPROVAL_STATUS.approval.id);
    }
  }

  /**
   * 否認
   */
  disapprovalGatePassages() {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('disapproval');
    } else {
      this.updateApprovalFlgGatePassages(APPROVAL_STATUS.unapproved.id);
    }
  }

  // 行単位の承認・承認解除用
  onToggleApprovalSingle = gatePassage => {
    if (!isTargetRoleId(USER_ROLES_IDS.PRIME_COMPANY, this.state.roleId)) {
      return;
    }
    this.setState({ selectedApprovalGatePassage: gatePassage });
    if (gatePassage.approval_flag === APPROVAL_STATUS.unapproved.id) {
      this.events.modal.handleVisible('approvalSingle');
    } else {
      this.events.modal.handleVisible('disapprovalSingle');
    }
  };

  updateApprovalFlgSingle = () => {
    const { selectedApprovalGatePassage } = this.state;
    const updateApprovalFlag =
      selectedApprovalGatePassage.approval_flag ===
      APPROVAL_STATUS.unapproved.id
        ? APPROVAL_STATUS.approval.id
        : APPROVAL_STATUS.unapproved.id;
    const params = {
      gate_passages: [
        {
          id: selectedApprovalGatePassage.id,
          approval_flag: updateApprovalFlag,
          lock_version: selectedApprovalGatePassage.lock_version,
        },
      ],
    };

    this.updateApprovalFlgList(params);
  };

  /**
   * 選択項目をコピー
   *  コピー先の日付を選択
   */
  copyGatePassages = onceAsyncRequest(async () => {
    if (_.isEmpty(this.state.selectedList)) {
      this.events.modal.handleVisible('copy');
    } else {
      if (_.isEmpty(this.state.passage_date)) {
        this.events.modal.handleVisible('copy');
      }

      let params = {
        ids: [],
      };

      _.each(this.state.selectedList, gate =>
        _.each(gate, gatePassage => {
          params.ids.push(gatePassage);
        })
      );

      params.passage_date = this.state.passage_date;
      await GatePassageService.copy(this.state.fieldId, params)
        .then(response => {
          if (response.message) {
            this.events.modal.handleVisible('copy');
            dialogLoader.show(ErrorDialog, {
              message: response.message,
              callback: {
                close: () => {
                  dialogLoader.close();
                },
              },
            });
            return;
          }

          if (response.result) {
            this.setState(
              {
                searchConditions: _.cloneDeep(paramsDefault),
                tempSearchConditions: _.cloneDeep(paramsDefault),
                refresh: true,
                selectedList: {},
                selectedGroup: {},
              },
              () => {
                this.events.modal.handleVisible('copy');
                this.reLoad();
              }
            );
            if (response.data.entities.manager_user_id_reset) {
              this.events.modal.handleVisible('copyNotComplete');
            }
          }
        })
        .catch(error => {
          if (error.status === 403) {
            this.events.modal.handleVisible('copyForbiddenError');
          }
        });
    }
  });

  /**
   * エラーメッセージ ダイアログ
   */
  showErrorDialog(message) {
    dialogLoader.show(ErrorDialog, {
      message,
      callback: {
        close: () => {
          dialogLoader.close();
        },
      },
    });
  }

  /**
   * 禁止時間帯設定
   */
  updateDisabledTimes() {
    const { disabledTimes, fieldId } = this.state;
    _.map(disabledTimes, disabledTime => {
      if (!_.isNull(disabledTime.target_id) || disabledTime.target_id !== '') {
        // 禁止時間が変更されてない場合
        if (disabledTime.update === true && disabledTime.changed === false) {
          return;
        }
        if (disabledTime.update === true && disabledTime.changed === true) {
          disabledTime.isQuiet = true;
          ScheduleLimitTimeService.update(
            fieldId,
            disabledTime.id,
            disabledTime
          ).then(response => {
            if (response.result) {
              const newTimes = _.map(disabledTimes, time => {
                return time.id === disabledTime.id ? disabledTime : time;
              });
              this.setState({
                disabledTimes: newTimes,
              });
            } else {
              this.showErrorDialog(response.message); // エラーメッセージ
              setTimeout(() => {
                this.getDisabledTimes();
              }, 1000);
            }
          });
        } else {
          ScheduleLimitTimeService.create(fieldId, disabledTime).then(
            response => {
              if (response.result) {
                return;
              } else {
                this.showErrorDialog(response.message); // エラーメッセージ
                setTimeout(() => {
                  this.getDisabledTimes();
                }, 1000);
              }
            }
          );
        }
      }
    });

    // 削除対応
    const { deleteScheduleLimitTimeIds } = this.state;
    if (_.size(deleteScheduleLimitTimeIds) > 0) {
      const params = {
        schedule_type: SCHEDULE_TYPES.gate.id,
        ids: deleteScheduleLimitTimeIds,
      };
      ScheduleLimitTimeService.destroy(this.state.fieldId, params).then();
    }

    this.setState(
      {
        searchConditions: _.cloneDeep(paramsDefault),
        tempSearchConditions: _.cloneDeep(paramsDefault),
        refresh: true,
        selectedList: {},
        selectedGroup: {},
        modalVisible: {
          disableTime: false,
        },
      },
      () => {
        this.getGates(() => {});
        this.getTotal();
      }
    );
  }

  /**
   * 禁止時間帯クリア
   */
  destroyScheduleLimitTimes() {
    ScheduleLimitTimeService.destroy(this.state.fieldId, {
      schedule_type: SCHEDULE_TYPES.gate.id,
      ids: [],
    }).then(response => {
      if (response.status === 200 || response.status === 0) {
        this.setState(
          {
            searchConditions: _.cloneDeep(paramsDefault),
            tempSearchConditions: _.cloneDeep(paramsDefault),
            refresh: true,
            selectedList: {},
            selectedGroup: {},
            isLoading: true,
          },
          () => {
            this.events.modal.handleVisible('success');
            this.getGates(() => {});
            this.getTotal();
          }
        );
      } else {
        this.events.modal.handleVisible('failure');
      }
    });
  }

  /**
   * 新規作成ボタンを表示するかどうか
   * @return boolean
   */
  isShowRegisterButton() {
    if (this.state.viewOnlyFlag) {
      return false;
    }

    // 選択されている行があれば「選択項目をコピー」を表示するので新規作成は表示しない
    return !this.someSelectedList();
  }

  /**
   * データを選択しているかどうか判定
   * @return boolean
   */
  someSelectedList() {
    return _.some(this.state.selectedList, item => !_.isEmpty(item));
  }

  /**
   * 編集画面へ遷移
   * @param gatePassage {object}
   */
  editRow = (e, gatePassage) => {
    if (e.target.closest('[data-unlink]')) {
      return;
    }
    // 左右スクロールした場合遷移しない
    if (this.state.clientX !== e.clientX) {
      return;
    }
    // 左右スクロールした場合遷移しない
    if (this.state.clientX !== e.clientX) {
      return;
    }
    _slideLoader.show(
      'GatePassageEdit',
      { state: { id: gatePassage.id } },
      this.props.vw
    );
  };

  craneEdit = (e, gatePassage) => {
    e.stopPropagation();
    if (_.isNull(gatePassage.crane_id)) {
      return;
    }

    const roleId = this.state.roleId;
    if (isPartnerCompanyRoleId(roleId)) {
      if (
        moment(gatePassage.use_date).isBefore(moment().format('YYYY/MM/DD'))
      ) {
        return;
      }
    }

    const id = gatePassage.crane_use_id;
    _slideLoader.show('CraneUseRegister', { state: { id } }, this.props.vw);
  };

  /**
   * 帳票出力
   * 車輌一覧（日次）
   */
  printDailyGatePassage() {
    if (this.state.calling) {
      return;
    }
    this.setState({ calling: true });
    const date = this.state.fromDate;
    let param = this.state.searchConditions;
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = moment(date).format('YYYY-MM-DD');
    param.file_code = FILE_CODE.PDF;
    param.report_code = 8;
    const reportName = ReportNames.GatePassageDaily;
    const newTab = window.open('/LayoutPrint', '_blank');
    PrintService.printReportByReportName(reportName, param)
      .then(async response => {
        const fileName = PrintService.makeReportFileName(
          reportName,
          param.file_code,
          date
        );
        let blob;
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                newTab.location.href = pdfUrl.get_pdf_url;
              }
            })
            .catch(error => {
              newTab.close();
              let result = {
                result: false,
                status: error.status,
                message: messageUtility.getMessage('E-001-401'),
              };
              blob = new Blob([JSON.stringify(result)], {
                type: 'application/json',
              });
            });
        } else {
          newTab.close();
          blob = new Blob([JSON.stringify(response)], {
            type: 'application/json',
          });
        }
        PrintUtility.printBlob(blob, fileName, param.file_code);
        this.setState({ calling: false });
      })
      .catch(error => {
        newTab.close();
        this.setState({ calling: false });
        alert(error);
      });
  }

  /**
   * 帳票出力
   * 車輌一覧（週間）
   */
  printWeeklyGatePassage() {
    if (this.state.calling) {
      return;
    }
    this.setState({ calling: true });
    const date = this.state.fromDate;
    let param = this.state.searchConditions;
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = moment(date).format('YYYY-MM-DD');
    param.file_code = FILE_CODE.PDF;
    param.report_code = 9;
    const reportName = ReportNames.GatePassageWeekly;
    const newTab = window.open('/LayoutPrint', '_blank');
    PrintService.printReportByReportName(reportName, param)
      .then(async response => {
        const fileName = PrintService.makeReportFileName(
          reportName,
          param.file_code,
          date
        );
        let blob;
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                newTab.location.href = pdfUrl.get_pdf_url;
              }
            })
            .catch(error => {
              newTab.close();
              let result = {
                result: false,
                status: error.status,
                message: messageUtility.getMessage('E-001-401'),
              };
              blob = new Blob([JSON.stringify(result)], {
                type: 'application/json',
              });
            });
        } else {
          newTab.close();
          blob = new Blob([JSON.stringify(response)], {
            type: 'application/json',
          });
        }
        PrintUtility.printBlob(blob, fileName, param.file_code);
        this.setState({ calling: false });
      })
      .catch(error => {
        newTab.close();
        this.setState({ calling: false });
        alert(error);
      });
  }

  /**
   * 帳票出力
   * 車輌搬出入予定月間集計表
   */
  printMonthlyGatePassage() {
    if (this.state.calling) {
      return;
    }
    this.setState({ calling: true });
    const date = this.state.fromDate;
    const param = _.cloneDeep(this.state.searchConditions);
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = moment(date).format('YYYY-MM-DD');
    param.file_code = FILE_CODE.PDF;
    param.report_code = 28;
    param.time_zone = 1;
    const reportName = ReportNames.GatePassageMonthly;
    const newTab = window.open('/LayoutPrint', '_blank');
    PrintService.printReportByReportName(reportName, param)
      .then(async response => {
        const fileName = PrintService.makeReportFileName(
          reportName,
          param.file_code,
          date
        );
        let blob;
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                newTab.location.href = pdfUrl.get_pdf_url;
              }
            })
            .catch(error => {
              newTab.close();
              let result = {
                result: false,
                status: error.status,
                message: messageUtility.getMessage('E-001-401'),
              };
              blob = new Blob([JSON.stringify(result)], {
                type: 'application/json',
              });
            });
        } else {
          newTab.close();
          blob = new Blob([JSON.stringify(response)], {
            type: 'application/json',
          });
        }
        PrintUtility.printBlob(blob, fileName, param.file_code);
        this.setState({ calling: false });
      })
      .catch(error => {
        newTab.close();
        this.setState({ calling: false });
        alert(error);
      });
  }

  render() {
    this.checkAllSelected();
    const isConferenceMode =
      SessionStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key;
    const slide = urlParamManager.getSlideParam();
    const {viewOnlyFlag, useConstructionSiteCodeFlg} = this.state;

    return (
      <div id='main' className='main'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>{HEADER_CONSTANTS.conference} - ゲート予定一覧</title>
          </Helmet>
        )}
        <ConferencePageHeader title={'ゲート予定一覧'} />
        <div
          id='scroll-parent'
          className='main__body'
          style={{ position: 'relative' }}
        >
          <div className='gate-schedulelist' ref={this.innerWindow}>
            <div className='gate-schedulelist__header'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    id='open-slide-view'
                    style={
                      this.isShowRegisterButton()
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    className='btn'
                    onClick={() => {
                      _slideLoader.show(
                        'GatePassageRegister',
                        this.FormNew,
                        this.props.vw
                      );
                    }}
                  >
                    新規作成
                  </button>
                  {!isConferenceMode && (
                    <button
                      id='open-slide-view'
                      style={
                        this.someSelectedList()
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                      className='btn'
                      onClick={() => {
                        this.events.modal.handleVisible('copy');
                      }}
                    >
                      選択項目をコピー
                    </button>
                  )}
                </li>
                <PrimeContractorToggle>
                  {!isConferenceMode && (
                    <React.Fragment>
                      <li className='btn-menu__item sm--hidden md--hidden'>
                        <div className='segment-line' />
                      </li>
                      <li className='btn-menu__item'>
                        <button
                          id='modal-open-confirm-selected'
                          className={`btn--effective ${
                            this.someSelectedList() ? '' : 'btn--disabled'
                          }`}
                          onClick={() =>
                            this.events.modal.handleVisible('approval')
                          }
                          disabled={!this.someSelectedList()}
                        >
                          選択項目を承認
                        </button>
                      </li>
                      <li className='btn-menu__item'>
                        <button
                          id='modal-open-confirm-deselected'
                          className={`btn--negative ${
                            this.someSelectedList() ? '' : 'btn--disabled'
                          }`}
                          onClick={() =>
                            this.events.modal.handleVisible('disapproval')
                          }
                          disabled={!this.someSelectedList()}
                        >
                          選択項目の承認解除
                        </button>
                      </li>
                    </React.Fragment>
                  )}
                </PrimeContractorToggle>
                <li className='btn-menu__item --fx-auto sm--hidden' />
                <li className='btn-menu__item sm--hidden'>
                  <button
                    id='modal-open-disable-time'
                    className='btn--sub'
                    style={
                      isPrimaryCompanyRoleId(this.state.roleId)
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    onClick={() =>
                      this.events.modal.handleVisible('disableTime')
                    }
                  >
                    禁止時間帯設定
                  </button>
                </li>
                <li className='btn-menu__item sm--hidden'>
                  <button
                    id='modal-open-document'
                    className='btn--sub'
                    onClick={() => this.events.modal.handleVisible('documents')}
                  >
                    印刷
                  </button>
                </li>
              </ul>
            </div>
            <GatePassagesSearchForm
              total={this.state.total}
              isOpened={this.state.isOpened}
              isFirstFormOpened={this.state.isFirstFormOpened}
              tempSearchConditions={this.state.tempSearchConditions}
              refreshed={this.state.refresh}
              callbacks={this.events.search}
              clearFlag={this.clearFlag}
              isConferenceMode={isConferenceMode}
              isPrimaryCompanyRoleId={isPrimaryCompanyRoleId(this.state.roleId)}
            />
            {useConstructionSiteCodeFlg && (
              <div className='gate-schedulelist__connect-futral'>
                未承認のゲート予定は万博システムに連携されません。情報を連携するために必ず承認済にしてください。
              </div>
            )}
            <div className='gate-schedulelist__list-header'>
              <ul className='btn-menu'>
                {!isConferenceMode && (
                  <React.Fragment>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-check-all'
                        className={
                          this.allChecked ? 'btn--sub disabled' : 'btn--stay'
                        }
                        onClick={() =>
                          this.events.table.handleSelectedAll(true)
                        }
                      >
                        表示項目を全て選択
                      </button>
                    </li>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-uncheck-all'
                        className={`btn-text${
                          this.allUnChecked ? ' disabled' : ''
                        }`}
                        onClick={() =>
                          this.events.table.handleSelectedAll(false)
                        }
                      >
                        選択中の項目を解除
                      </button>
                    </li>
                    {this.state.loadingDisabledTimes === true &&
                      this.state.modalVisible.disableTime === false && (
                        <ClipLoader size={24} color={'#cccccc'} />
                      )}
                  </React.Fragment>
                )}
              </ul>
              <div className='gate-schedulelist__list-description'>
                <div className='gage-sample'>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>スポット</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--spot'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>搬入</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--carryin'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>搬出</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--carryout'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>占有</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--occupation'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                  <div className='gage-sample__item'>
                    <div className='gage-sample__label'>
                      <span className='label'>禁止時間帯</span>
                    </div>
                    <div className='gage-sample__element'>
                      <div className='gage--forbid'>
                        <div className='gage__bar' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='gage-table'>
              <div
                className='gage-table__scroller'
                style={{
                  // overflow: isConferenceMode ? 'visible' : 'visible',
                  overflow: 'visible',
                }}
              >
                <div
                  className='gage-table__left'
                  style={{
                    minWidth: _.ceil(this.state.innerWidth * 0.6),
                  }}
                >
                  <div
                    className='gage-table__left-inner'
                    style={{
                      minWidth: _.ceil(this.state.innerWidth * 0.6) + 1,
                      cursor: isConferenceMode
                        ? 'pointer'
                        : this.state.isScrolling
                        ? 'grabbing'
                        : 'grab',
                    }}
                  >
                    <div
                      id='infinityscroll-target'
                      ref={this._scroller}
                      onMouseDown={this.onMouseDown}
                      onMouseMove={this.onMouseMove}
                    >
                      <table className='data-table'>
                        <thead className='data-table__header'>
                          <tr>
                            {!isConferenceMode && (
                              <React.Fragment>
                                <th
                                  id='table-value-icon'
                                  className='data-table__head'
                                >
                                  <div />
                                </th>
                                <th className='data-table__head'>日付</th>
                                <th className='data-table__head'>ステータス</th>
                              </React.Fragment>
                            )}
                            <th
                              id='value-table--id'
                              className='data-table__head'
                            >
                              受付No
                            </th>
                            {useConstructionSiteCodeFlg && (
                              <React.Fragment>
                                <th
                                  id='value-table--status'
                                  className='data-table__head'
                                >
                                  受諾状態
                                </th>
                                <th
                                  id='value-table--truck'
                                  className='data-table__head'
                                >
                                  車両番号登録
                                </th>
                              </React.Fragment>
                            )}
                            <th
                              id='value-table--delivery-company'
                              className='data-table__head'
                            >
                              車両手配業者
                            </th>
                            <th
                              id='value-table--track'
                              className='data-table__head'
                            >
                              車両/台数/荷種
                            </th>
                            <th
                              id='value-table--constructor'
                              className='data-table__head'
                            >
                              元請担当者
                            </th>
                            <th
                              id='value-table--note'
                              className='data-table__head'
                            >
                              備考
                            </th>
                            <th
                              id='value-table--track-name'
                              className='data-table__head'
                            >
                              揚重機予定
                            </th>
                            {/* {isConferenceMode && (
                              <th
                                id='value-table--gate-schedule'
                                style={{
                                  width: '40%',
                                  minWidth: '40vw',
                                  backgroundColor: '#666666',
                                  zIndex: 2,
                                }}
                              >
                                <TimeBarHeader
                                  scheduleLimitTimes={
                                    this.state.scheduleLimitTimes
                                  }
                                />
                              </th>
                            )} */}
                          </tr>
                        </thead>
                        {_.map(this.getOrderedGates(this.props.items), gate =>
                          _.isEmpty(gate.children) ? null : (
                            <GatePassagesContents
                              key={gate.id}
                              gate={gate}
                              selectedGroup={this.isSelectedGroup(gate.id)}
                              isSelected={this.isSelected}
                              callbacks={this.events.table}
                              userRollId={this.state.roleId}
                              isConferenceMode={isConferenceMode}
                              scheduleLimitTimes={this.state.scheduleLimitTimes}
                              disabledTimes={_.filter(
                                this.state.disabledTimes,
                                time => {
                                  return time.target_id === gate.id;
                                }
                              )}
                              viewOnlyFlag={viewOnlyFlag}
                              isTimeBarReset={this.state.isTimeBarReset}
                              useConstructionSiteCodeFlg={
                                useConstructionSiteCodeFlg
                              }
                              onToggleApprovalSingle={
                                this.onToggleApprovalSingle
                              }
                            />
                          )
                        )}
                      </table>
                      <InfinityScrollLoad
                        targetId='scroll-parent'
                        total={this.props.totalCount}
                        isLoading={this.props.isLoading}
                        callback={this.getAddGates}
                      />
                    </div>
                  </div>
                </div>
                {
                  <div
                    className='gage-table__right no-shadow'
                    ref={this._rightTable}
                    style={{
                      minWidth: _.floor(this.state.innerWidth * 0.4),
                    }}
                  >
                    <div>
                      <table
                        className='data-table'
                        style={{
                          position: 'relative',
                          overflowX: 'auto',
                        }}
                      >
                        <thead className='data-table__header'>
                          <tr className=''>
                            <th
                              id='value-table--gate-schedule'
                              className=''
                              style={{
                                backgroundColor: '#666666',
                                zIndex: 3,
                              }}
                            >
                              <TimeBarHeader
                                scheduleLimitTimes={
                                  this.state.scheduleLimitTimes
                                }
                              />
                            </th>
                          </tr>
                        </thead>
                        {_.map(this.getOrderedGates(this.props.items), gate =>
                          _.isEmpty(gate.children) ? null : (
                            <tbody
                              id={`group-${gate.id}`}
                              key={gate.id}
                              className='table__group show'
                            >
                              <tr className='table-section-header'>
                                <td
                                  className='data-table__gage-cover'
                                  style={{ borderTop: '1px solid #7C7C7C' }}
                                >
                                  <span className='data-table__gage-cover-spacer' />
                                </td>
                              </tr>
                              {_.map(gate.children, data => (
                                <tr key={data.id} className='data-table__item'>
                                  <td
                                    data-unlink
                                    className='data-table__gage-bg'
                                  >
                                    <SchaduleBar
                                      useStartTime={data.passage_start_time}
                                      useEndTime={data.passage_end_time}
                                      spotFlag={data.spot_flag}
                                      data={data}
                                      callback={
                                        this.events.table.handleGageUpdate
                                      }
                                      isForeman={isTargetRoleId(
                                        [USER_ROLES.foreman],
                                        this.state.roleId
                                      )}
                                      isGate={true}
                                      scheduleLimitTimes={
                                        this.state.scheduleLimitTimes
                                      }
                                      disabledTimes={_.filter(
                                        this.state.disabledTimes,
                                        time => {
                                          return time.target_id === gate.id;
                                        }
                                      )}
                                      viewOnlyFlag={
                                        viewOnlyFlag ||
                                        (useConstructionSiteCodeFlg &&
                                          isStatusAcceptGateFutral(
                                            data.gate_fleet_status
                                          ))
                                      }
                                      isTimeBarReset={this.state.isTimeBarReset}
                                      tableRef={this._rightTable}
                                    />
                                  </td>
                                </tr>
                              ))}
                              <tr
                                className='see-more'
                                style={
                                  gate.childrenLoaded
                                    ? { display: 'none' }
                                    : { display: 'table-row' }
                                }
                              >
                                <td colSpan='8'>
                                  <button
                                    className='see-more__button see-more__button__blue'
                                    onClick={() =>
                                      this.events.table.handleSeeMore(gate.id)
                                    }
                                  >
                                    <i className='see-more__button__icon' />
                                    <p className='see-more__button__text'>
                                      さらに表示する
                                    </p>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          )
                        )}
                      </table>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={this.state.modalVisible.approval === true}
          title={messageUtility.getMessage(
            'I-001-407',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-404',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-007')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.events.modal.approval}
          onCancel={() => this.events.modal.handleVisible('approval')}
        />
        <Confirmation
          visible={this.state.modalVisible.disapproval === true}
          title={messageUtility.getMessage(
            'I-001-408',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-417',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-020')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.events.modal.disapproval}
          onCancel={() => this.events.modal.handleVisible('disapproval')}
        />
        <Confirmation
          visible={this.state.modalVisible.approvalSingle === true}
          title={messageUtility.getMessage(
            'I-001-407',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-404',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-007')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.updateApprovalFlgSingle}
          onCancel={() => this.events.modal.handleVisible('approvalSingle')}
        />
        <Confirmation
          visible={this.state.modalVisible.disapprovalSingle === true}
          title={messageUtility.getMessage(
            'I-001-408',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          message={messageUtility.getMessage(
            'I-001-417',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-020')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.updateApprovalFlgSingle}
          onCancel={() => this.events.modal.handleVisible('disapprovalSingle')}
        />
        <DisableTime
          visible={this.state.modalVisible.disableTime === true}
          workTime={this.state.workTime}
          disabledTimes={this.state.disabledTimes}
          loadingDisabledTimes={this.state.loadingDisabledTimes}
          scheduleLimitTimes={this.state.scheduleLimitTimes}
          callbacks={this.events.modal}
          planType={SCHEDULE_TYPES.gate.name}
          idUsePlanName='gate-passages'
        />
        <Modal modalRoot='root' modalState={this.state.modalVisible.documents}>
          <GatePassageDocuments
            show={this.state.modalVisible.documents}
            calling={this.state.calling}
            callbacks={this.events.modal}
          />
        </Modal>
        <CopyPlan
          visible={this.state.modalVisible.copy === true}
          setKey='passage_date'
          targetDate={this.state.passage_date}
          callbacks={this.events.modal}
        />
        <Confirmation
          visible={this.state.modalVisible.confirmation === true}
          message={messageUtility.getMessage('I-001-310')}
          confirmButtonText={messageUtility.getMessage('I-000-021')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.events.modal.destroy}
          onCancel={() => this.events.modal.handleVisible('disableTime')}
        />
        <Information
          visible={this.state.modalVisible.success === true}
          message={messageUtility.getMessage('I-001-311')}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.events.modal.handleVisible('success')}
          buttonClassName='btn--sm--sub'
        />
        <Information
          visible={this.state.modalVisible.failure === true}
          message={messageUtility.getMessage('E-001-307')}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.events.modal.handleVisible('failure')}
          buttonClassName='btn--sm--sub'
        />
        <Information
          title={this.state.modalVisible.approvalTitle}
          visible={this.state.modalVisible.approvalStatus === true}
          message={this.state.modalVisible.approvalMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.events.modal.handleVisible('approvalStatus')}
          multilineText={true}
        />

        {/* 時間更新権限エラーダイアログ */}
        <Information
          visible={this.state.modalVisible.timeForbiddenError === true}
          message='権限が無いため、時間の更新に失敗しました。'
          buttonText='了解'
          onClose={() => this.events.modal.handleVisible('timeForbiddenError')}
          buttonClassName='btn--sm--sub'
        />

        {/* コピー権限エラーダイアログ */}
        <Information
          visible={this.state.modalVisible.copyForbiddenError === true}
          message='権限が無いため、予定のコピーに失敗しました。'
          buttonText='了解'
          onClose={() => this.events.modal.handleVisible('copyForbiddenError')}
          buttonClassName='btn--sm--sub'
        />

        <Information
          title={messageUtility.getMessage('I-001-434')}
          visible={this.state.modalVisible.copyNotComplete === true}
          message={messageUtility.getMessage(
            'I-001-435',
            `${SCHEDULE_TYPES.gate.name}予定`
          )}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.events.modal.handleVisible('copyNotComplete')}
          multilineText={true}
        />
      </div>
    );
  }
}

export class GatePassages extends React.Component {
  getParents = async params => {
    const response = await GateService.listForGatePassages(
      SessionStorageService.getFieldId(),
      {
        ...params,
        isQuiet: true,
      }
    );

    if (response.result) {
      return {
        items: response.data.entities.gates,
        totalCount: response.data.total,
      };
    } else {
      return {
        items: [],
        totalCount: 0,
      };
    }
  };

  getChildren = async params => {
    const response = await GatePassageService.list(
      SessionStorageService.getFieldId(),
      { ...params, isQuiet: true }
    );

    if (response.result) {
      return _.map(response.data.entities.gate_passages, gatePassage => ({
        groupId: gatePassage.gate_id,
        items: gatePassage.gates,
        totalCount: gatePassage.total_gate_passage,
      }));
    } else {
      return [];
    }
  };

  render() {
    return (
      <GroupListContainer
        getParents={this.getParents}
        getChildren={this.getChildren}
        render={containerProps => (
          <GatePassagesBody {...{ ...this.props, ...containerProps }} />
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GatePassages.jsx